export const ToastIcons = {
  success: 'checkmark',
  danger: 'close-circle',
  warning: 'alert-circle',
  primary: 'information-circle',
};

export const StorageKeys = {
  agent: 'agent',
};
